
import {FETCH_FILTER_REQUEST,FETCH_FILTER_SUCCESS,FETCH_FILTER_ERROR, APPLY_FILTER} from './filterConstTypes'


const initialFilterState = {
    loading: false,
    filterdata: {
        "departurelabel": "Departure Date",
        "participantslabel": "Participants",
        "participantadultlabel": "Adults",
        "participantchildlabel": "Child",
        "participantinfantlabel": "Infants",
        "participantyouthyouth": "Youths",
            "type":{},
            "where": {},
            "when": {},
            "level": {},
            "length": {}
    },
    error: ''
}

export const filterReducer = (state = initialFilterState, action) => {
    
    switch (action.type) {
        case FETCH_FILTER_REQUEST:
            return {
                ...state,
                loading: true
            }
        case FETCH_FILTER_SUCCESS:
            return {
                ...state,
                filterdata: action.payload,
                error: ''
            }
        case FETCH_FILTER_ERROR:
            return {
                ...state,
                filterdata: {},
                error: action.payload
            }
        default:
           return state;
    }
}

